const colors = {
  primary: '#80d1ff',
  hover: '#98daff',
  hoverGray: '#f7f7f7',
  gray: '#6f6f6f',
  darkGray: '#686868',
  light: '#d2efff',
  error: '#eb1000',
  categoryBlue: '#ecf8ff',
};

module.exports = { colors };
